import React, {useEffect, useState} from "react";
import Modal from "../../components/Modal/Modal";
import {GenerateForm} from "../../components/cardViewComponents/GenerateForm";
import {validationData} from "../../components/UI/formValid";
import {validationConfig} from "../../components/cardViewComponents/validationConfig";
import Notif from "../../components/Notif";
import {createDocumentService, getDocumentPrepareService} from "../../services/document/document";
import {createEvent} from "../../services/other/events";

const fieldsConfig = {
    name: {
        label: 'Название',
        type: 'text',
        className: 'w100',
        validation: { required: true, maxLength: 255 }, zone: 1
    },
    status_id: {
        label: 'Статус',
        type: 'select',
        options: [],
        className: 'w100',
        options_from: 'statuses',
        prepare: 'statuses', val: 'id', lab: 'value',
        validation: { required: true, maxLength: 255 }, zone: 1
    },
    type_id: {
        label: 'Статус',
        type: 'select',
        options: [],
        className: 'w100',
        options_from: 'types',
        prepare: 'types', val: 'id', lab: 'value',
        validation: { required: true, maxLength: 255 }, zone: 1
    },
    contact_id: {
        label: 'Контакт',
        type: 'entity',
        link: "/ajax/contact?fields=id,name&filter[name][like]=",
        result: 'name',
        entity_from: 'contact',
        entityName: 'name',
        className: 'w100',
        zone: 1,
    },
    account_id: {
        label: 'Контрагент',
        type: 'entity',
        link: "/ajax/account?fields=id,name&filter[name][like]=",
        result: 'name',
        entity_from: 'account',
        entityName: 'name',
        className: 'w100',
        zone: 1,
    },
    owner_id: {
        label: 'Ответственный',
        type: 'entity',
        link: "/ajax/settings/user?filter[name][like]=",
        result: 'name',
        entity_from: 'owner',
        entityName: 'name',
        className: 'w100',
        minLength: 0,
        zone: 1
        // redirectLink
    },
}

export const DocumentModal = ({ isOpen, close, history, save, data: modalData = {} }) => {
    const [loading, setLoading] = useState(true)
    const [errors, setErrors] = useState({})
    const [disabled, setDisabled] = useState({})
    const [values, setValues] = useState({
        account_id: modalData && modalData.account_id,
        account: modalData && modalData.account,
        contact_id: modalData && modalData.contact_id,
        contact: modalData && modalData.contact,
        name: '',
        owner_id: null,
        status_id: '',
        statuses: [],
        type_id: '',
        types: [],
        tch: false
    })

    const getPrepare = async () => {
        const { status, data } = await getDocumentPrepareService()
        if((status === 200 || status === 201) && data && data.statuses && data.types) {
            setValues({
                ...values,
                statuses: data.statuses,
                status_id: data.statuses[0].id,
                types: data.types,
                type_id: data.types[0].id,
                name: 'Документ №' + data.nextId
            })
        }
        setLoading(false)
    }

    const saveItem = async () => {
        const errorsData = validationData(values, validationConfig(fieldsConfig));
        setErrors(errorsData)
        if(Object.keys(errorsData).length > 0) {
            Notif('required-fields')
            return false;
        }

        setLoading(true)
        const { name, status_id, type_id, owner_id, account_id, contact_id } = values
        const { status, data } = await createDocumentService({ data: {
            name, status_id, type_id, owner_id, account_id, contact_id, opportunity_id: modalData && modalData.opportunity_id, order_id: modalData && modalData.order_id, project_id: modalData && modalData.project_id
        }})
        if((status === 200 || status === 201) && data.id) {
            if(save) {
                save(); setTimeout(close, 200);
                createEvent({ user_id: window.location.host, user_name: "---", event_type: "createDocument" }).then()
            } else {
                history.push(`/document/${data.id}`)
                createEvent({ user_id: window.location.host, user_name: "---", event_type: "createDocument" }).then()
            }
            Notif('save')
        }
        setLoading(false)
    }

    useEffect(() => {
        getPrepare().then()
    }, [])

    const changeFields = (key, value, item) => {
        let obj = {}
        if(item) {
            if(item === 'clear') obj[fieldsConfig[key].entity_from] = null
            else obj[fieldsConfig[key].entity_from] = item
        }

        setValues({ ...values, ...obj, [key]: item ? item.id : value, tch: false })
    }

    return (
        <Modal isOpen={isOpen} save={saveItem} close={close} loading={loading} showLeaveModal tch={values.tch} title={'Создать лид'}>
            <GenerateForm
                config={fieldsConfig}
                { ...{ values, errors, disabled } }
                onChange={changeFields}
                onSaveData={saveItem}
            />
        </Modal>
    )
}